<template>
    <div class="p-12 container">
        <h2>Domains</h2>

        <nav class="sau-menu-horizontal md mb-4">
            <ul>
                <li><router-link to="/order/domain/register" data-tables-nav :class="{active: routeName === 'Register'}" title="Register a Domain">Register</router-link></li>
                <li><router-link to="/order/domain/renew" data-tables-nav :class="{active: routeName === 'Renew'}" title="Renew a Domain">Renew</router-link></li>
                <li><router-link to="/order/domain/transfer" data-tables-nav :class="{active: routeName === 'Transfer'}" title="Transfer a Domain">Transfer</router-link></li>
            </ul>
        </nav>


        <keep-alive>
            <router-view
                :order="order"
                :data="data"
            ></router-view>
        </keep-alive>

    </div>

</template>

<script>
    export default {

        props: {
            order: Object,
            data: Object,
        },

        computed: {
            routeName() {
                return this.$route.name;
            }
        }

    }
</script>

<style scoped>
    .sau-menu-horizontal {
        border-bottom: 1px solid #e5e5e5;
    }
    .sau-menu-horizontal ul li {
        display: inline-block;
    }
</style>
